module.exports = __webpack_public_path__ + "static/media/IconTemplates_-68.b83ad8c4.svg";